import { useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import TabDataContainer from "../../containers/TabDataContainer";
import TabConfig from "../TabConfig";
import { StyledOngletwrapper } from "./styles";

const OngletWrapper = ({
  getTabData,
  updateTabSelected,
  tabSelected,
  tabsConfig,
  getOngletsConfig,
  yearSelected,
}) => {
  const { state: onglet = {} } = useLocation();

  const [isConfigMode, setIsConfigMode] = useState(false);

  useEffect(() => {
    if (onglet?.id) {
      updateTabSelected(onglet.id);
    }
  }, [onglet, updateTabSelected]);

  useEffect(() => {
    if (tabSelected && yearSelected) {
      getTabData(tabSelected, yearSelected);
    }
  }, [getTabData, tabSelected, yearSelected]);

  const handleSwitchMode = () => {
    setIsConfigMode(!isConfigMode);
  };

  const theme = useTheme();

  return (
    <StyledOngletwrapper theme={theme}>
      {isConfigMode ? (
        <TabConfig
          handleSwitchMode={handleSwitchMode}
          tabsConfig={tabsConfig}
          tabSelected={tabSelected}
          getOngletsConfig={getOngletsConfig}
        />
      ) : (
        <TabDataContainer handleSwitchMode={handleSwitchMode} />
      )}
    </StyledOngletwrapper>
  );
};

export default OngletWrapper;
